import { render, staticRenderFns } from "./printPage.vue?vue&type=template&id=31c43bc2&scoped=true&"
import script from "./printPage.vue?vue&type=script&lang=js&"
export * from "./printPage.vue?vue&type=script&lang=js&"
import style0 from "./printPage.vue?vue&type=style&index=0&id=31c43bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c43bc2",
  null
  
)

export default component.exports